import { CompanyDetailsTabWebComponent } from './component/CompanyDetailsTabWebComponent';
import { WEB_COMPONENT_COMPANY_DETAILS_TAB } from '../../../webcomponents.constants';

export { CompanyDetailsTabWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_DETAILS_TAB, CompanyDetailsTabWebComponent);
